export const Demand = () => {
  return (
    <div className="flex justify-center">
      <div className="px-[15rem] py-[50px] w-[1920px]">
        <div className="text-[#333] text-center font-['Alibaba_PuHuiTi_3.0'] text-[45px] font-bold leading-[120%] tracking-[4.5px] mb-[50px]">
          满足你在TikTok上的几乎任何使用需求
        </div>
        <div className="flex gap-[30px]">
          <div className=" p-[40px] bg-gradient-to-b from-blue-50 to-white rounded-[10px] border-2 border-white">
            <div className="self-stretch justify-start text-zinc-800 text-2xl font-bold font-['Alibaba_PuHuiTi_3.0']">
              经得起三方检测的独享原生家庭IP
            </div>
            <div className="self-stretch justify-start text-slate-700 text-xs font-light font-['Alibaba_PuHuiTi_3.0'] mt-[16px]">
              我们严格挑选优质的海外当地真实双ISP住宅IP资源，经主流IP纯净度网站检测，均为纯净家宽IP
            </div>
            <div className="flex mt-[45px] h-[272px] gap-[50px]">
              <img
                src="/imgs/tiktok/demand-1.png"
                className="w-[412px] h-[272px]"
              />
              <div className="py-[20px] flex flex-col justify-between">
                <div className="w-36 h-12 px-5 py-4 bg-gradient-to-r from-[#64B7FF] via-[#89ABFF] to-[#B99BFF] shadow-[0_7px_14px_0_rgba(0,0,0,0.10)] rounded-[10px] shadow-[0px_7px_14px_0px_rgba(0,0,0,0.10)] inline-flex justify-center items-center gap-2.5">
                  <div className="justify-start text-white text-2xl font-bold font-['Alibaba_PuHuiTi_3.0']">
                    双ISP
                  </div>
                </div>
                <div className="w-36 h-12 px-5 py-4 bg-gradient-to-r from-[#64B7FF] via-[#89ABFF] to-[#B99BFF] shadow-[0_7px_14px_0_rgba(0,0,0,0.10)] rounded-[10px] shadow-[0px_7px_14px_0px_rgba(0,0,0,0.10)] inline-flex justify-center items-center gap-2.5">
                  <div className="justify-start text-white text-2xl font-bold font-['Alibaba_PuHuiTi_3.0']">
                    值得信赖
                  </div>
                </div>
                <div className="w-36 h-12 px-5 py-4 bg-gradient-to-r from-[#64B7FF] via-[#89ABFF] to-[#B99BFF] shadow-[0_7px_14px_0_rgba(0,0,0,0.10)] rounded-[10px] shadow-[0px_7px_14px_0px_rgba(0,0,0,0.10)] inline-flex justify-center items-center gap-2.5">
                  <div className="justify-start text-white text-2xl font-bold font-['Alibaba_PuHuiTi_3.0']">
                    纯净家宽
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-1 p-[40px] bg-gradient-to-b from-blue-50 to-white rounded-[10px] border-2 border-white">
            <div className="self-stretch justify-start text-zinc-800 text-2xl font-bold font-['Alibaba_PuHuiTi_3.0']">
              合规金融级国际专线，业务有保障
            </div>
            <div className="flex gap-[15px] justify-center items-center mt-[60px]">
              <div>
                <div className="self-stretch justify-start text-slate-700 text-base font-medium font-['Alibaba_PuHuiTi_3.0']">
                  线路合规
                </div>
                <div className="mt-[6px] self-stretch justify-start text-slate-700 text-sm font-light font-['Alibaba_PuHuiTi_3.0']">
                  底层线路源自国内三大运营商，服务器等均采用腾讯云、火山云等合规大厂服务商，并且光年无界拥有相关合规化资质。
                </div>
                <div className="mt-[20px] self-stretch justify-start text-slate-700 text-base font-medium font-['Alibaba_PuHuiTi_3.0']">
                  专线稳定
                </div>
                <div className="mt-[6px] self-stretch justify-start text-slate-700 text-sm font-light font-['Alibaba_PuHuiTi_3.0']">
                  使用自研K-WAN加速引擎，采用金融级国际专线，延迟低稳定不丢包
                </div>
                <div className="mt-[20px] self-stretch justify-start text-slate-700 text-base font-medium font-['Alibaba_PuHuiTi_3.0']">
                  全球部署
                </div>
                <div className="mt-[6px] self-stretch justify-start text-slate-700 text-sm font-light font-['Alibaba_PuHuiTi_3.0']">
                  光年骨干网络节，支持美国、东南亚、欧洲、南美等TK盈盖的地区，业务拓展有保障
                </div>
              </div>
              <img
                src="/imgs/tiktok/demand-2.png"
                className="w-[284px] h-[284px]"
              />
            </div>
          </div>
        </div>

        <div className="flex gap-[30px]">
          <div className="flex-1 flex justify-between">
            <DemandItem
              title="跨境直播带货"
              description="TikTok平台开展直播带货，低成本，高安全稳定性，更流畅、真实的展现商品的功能优势特点。"
            >
              <img
                src="/imgs/tiktok/item-1.png"
                className="w-44 h-64 mt-[33px]"
              />
            </DemandItem>
            <DemandItem
              title="多场景跨境直播"
              description="TikTok平台开展直播带货，低成本，高安全稳定性，更流畅、真实的展现商品的功能优势特点。"
            >
              <img
                src="/imgs/tiktok/item-2.png"
                className="w-44 h-64 mt-[33px]"
              />
            </DemandItem>
          </div>
          <div className="flex-1 flex justify-between">
            <DemandItem
              title="社媒短视频运营"
              description="在TikTok平台上运营账号，通过创意视频直观展示产品的外观、细节、使用方法，使用户更容易理解产品的特点和优势，实现视频的种草与带货。"
            >
              <img
                src="/imgs/tiktok/item-3.png"
                className="w-44 h-64 mt-[13px]"
              />
            </DemandItem>

            <div className="w-80 h-[473px] p-[40px] bg-gradient-to-b from-slate-100 to-white rounded-[10px] border-2 border-white">
              <div className="w-64 justify-start text-zinc-800 text-xl font-bold font-['Alibaba_PuHuiTi_3.0']">
                支持多账号、多IP同时直播
              </div>
              <div className="w-64 justify-start text-slate-700 text-sm font-light font-['Alibaba_PuHuiTi_3.0'] mt-[8px]">
                光年CPE路由加速盒子支持多条网线/多设备链接WIFI同时使用，每条线路均可配置不同国家/地区IP，完美支持多账号同时开播。
              </div>
              <div className=" flex justify-center mt-[20px]">
                <div className="w-full">
                  <div className="w-64 px-2.5 py-4 bg-white rounded-[10px] outline outline-1 outline-offset-[-1px] outline-blue-400 inline-flex justify-start items-center gap-3">
                    <div className="w-6 h-6 relative overflow-hidden">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_8133_3359)">
                          <path
                            d="M0 12C0 5.37269 5.37269 0 12 0C18.6273 0 24 5.37269 24 12C24 18.6273 18.6273 24 12 24C5.37269 24 0 18.6273 0 12ZM9.82759 16.5617C9.97832 16.7171 10.184 16.8073 10.4004 16.8128C10.6168 16.8184 10.8269 16.7389 10.9854 16.5914L18.8491 9.28055C19.0087 9.13083 19.1024 8.92402 19.1099 8.70535C19.1174 8.48668 19.038 8.27394 18.889 8.11367C18.7401 7.9534 18.5337 7.85863 18.3151 7.8501C18.0964 7.84157 17.8833 7.91996 17.7223 8.06814L10.4772 14.8543L7.07586 11.347C7.00045 11.268 6.91012 11.2046 6.81009 11.1606C6.71007 11.1167 6.60232 11.0929 6.49308 11.0908C6.38383 11.0887 6.27525 11.1082 6.17359 11.1483C6.07193 11.1883 5.97921 11.2481 5.90078 11.3242C5.82235 11.4003 5.75977 11.4912 5.71663 11.5915C5.6735 11.6919 5.65068 11.7999 5.64947 11.9091C5.64827 12.0184 5.66872 12.1268 5.70964 12.2281C5.75055 12.3295 5.81113 12.4217 5.88786 12.4994L9.828 16.5617H9.82759Z"
                            fill="#74B9FF"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_8133_3359">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="flex-1 justify-start text-zinc-800 text-base font-normal font-['Alibaba_PuHuiTi_3.0'] leading-tight">
                      不同国家 多账号直播
                    </div>
                  </div>
                  <div className="mt-[25px] w-64 px-2.5 py-4 bg-white rounded-[10px] outline outline-1 outline-offset-[-1px] outline-blue-400 inline-flex justify-start items-center gap-3">
                    <div className="w-6 h-6 relative overflow-hidden">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_8133_3359)">
                          <path
                            d="M0 12C0 5.37269 5.37269 0 12 0C18.6273 0 24 5.37269 24 12C24 18.6273 18.6273 24 12 24C5.37269 24 0 18.6273 0 12ZM9.82759 16.5617C9.97832 16.7171 10.184 16.8073 10.4004 16.8128C10.6168 16.8184 10.8269 16.7389 10.9854 16.5914L18.8491 9.28055C19.0087 9.13083 19.1024 8.92402 19.1099 8.70535C19.1174 8.48668 19.038 8.27394 18.889 8.11367C18.7401 7.9534 18.5337 7.85863 18.3151 7.8501C18.0964 7.84157 17.8833 7.91996 17.7223 8.06814L10.4772 14.8543L7.07586 11.347C7.00045 11.268 6.91012 11.2046 6.81009 11.1606C6.71007 11.1167 6.60232 11.0929 6.49308 11.0908C6.38383 11.0887 6.27525 11.1082 6.17359 11.1483C6.07193 11.1883 5.97921 11.2481 5.90078 11.3242C5.82235 11.4003 5.75977 11.4912 5.71663 11.5915C5.6735 11.6919 5.65068 11.7999 5.64947 11.9091C5.64827 12.0184 5.66872 12.1268 5.70964 12.2281C5.75055 12.3295 5.81113 12.4217 5.88786 12.4994L9.828 16.5617H9.82759Z"
                            fill="#74B9FF"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_8133_3359">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="flex-1 justify-start text-zinc-800 text-base font-normal font-['Alibaba_PuHuiTi_3.0'] leading-tight">
                      多个IP 共享单条线路带宽
                    </div>
                  </div>
                  <div className="mt-[25px] w-64 px-2.5 py-4 bg-white rounded-[10px] outline outline-1 outline-offset-[-1px] outline-blue-400 inline-flex justify-start items-center gap-3">
                    <div className="w-6 h-6 relative overflow-hidden">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_8133_3359)">
                          <path
                            d="M0 12C0 5.37269 5.37269 0 12 0C18.6273 0 24 5.37269 24 12C24 18.6273 18.6273 24 12 24C5.37269 24 0 18.6273 0 12ZM9.82759 16.5617C9.97832 16.7171 10.184 16.8073 10.4004 16.8128C10.6168 16.8184 10.8269 16.7389 10.9854 16.5914L18.8491 9.28055C19.0087 9.13083 19.1024 8.92402 19.1099 8.70535C19.1174 8.48668 19.038 8.27394 18.889 8.11367C18.7401 7.9534 18.5337 7.85863 18.3151 7.8501C18.0964 7.84157 17.8833 7.91996 17.7223 8.06814L10.4772 14.8543L7.07586 11.347C7.00045 11.268 6.91012 11.2046 6.81009 11.1606C6.71007 11.1167 6.60232 11.0929 6.49308 11.0908C6.38383 11.0887 6.27525 11.1082 6.17359 11.1483C6.07193 11.1883 5.97921 11.2481 5.90078 11.3242C5.82235 11.4003 5.75977 11.4912 5.71663 11.5915C5.6735 11.6919 5.65068 11.7999 5.64947 11.9091C5.64827 12.0184 5.66872 12.1268 5.70964 12.2281C5.75055 12.3295 5.81113 12.4217 5.88786 12.4994L9.828 16.5617H9.82759Z"
                            fill="#74B9FF"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_8133_3359">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="flex-1 justify-start text-zinc-800 text-base font-normal font-['Alibaba_PuHuiTi_3.0'] leading-tight">
                      仅需一个CPE路由加速盒子即可满足最多个账号同时开
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DemandItem = (props: {
  title: string;
  description: string;
  children: React.ReactNode;
}) => {
  return (
    <div className="w-[337px] h-[473px] p-[40px] bg-gradient-to-b from-[#F0F5FC] to-[#FFFFFF] rounded-[10px] border-[2px] border-solid [border-image:linear-gradient(180deg,rgba(255,255,255,1),rgba(240,244,252,1))_2_2]">
      <div className=" justify-start text-zinc-800 text-2xl font-bold font-['Alibaba_PuHuiTi_3.0']">
        {props.title}
      </div>
      <div className=" justify-start text-slate-700 text-sm font-light font-['Alibaba_PuHuiTi_3.0'] mt-[8px]">
        {props.description}
      </div>
      <div className=" flex justify-center">{props.children}</div>
    </div>
  );
};
